import { LoadingIcon as LoadingDs, Typography } from "@packages/ds";
import styled from "styled-components";

import { ButtonWrapper as ButtonWrapperDefault } from "ds/Button";
import { Separator as DSSeparator } from "ds/Dropdown";
import InputDS from "ds/Input";
import * as Radio from "ds/Radio";
import * as Sticker from "ds/Sticker";

export const DialogWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  gap: 8px;
`;

export const Separator = styled(DSSeparator)`
  margin: 24px 0px;
`;

export const SimpleBodyText = styled(Typography.BodyText)`
  display: inline;
`;

export const InputsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 24px;
`;

export const Input = styled(InputDS)`
  & > input {
    width: 100%;
  }
`;

export const ResourceBodyText = styled(Typography.BodyText)`
  margin-bottom: 8px;
`;
export const DialogWrapperSizing = styled.div`
  display: flex;
  gap: 8px;
`;

export const RadioGroupWrapper = styled.div`
  margin-top: 24px;
`;

export const RadioGroup = styled(Radio.Group)`
  margin-top: 8px;
`;

export const RadioInput = styled(Radio.Input)`
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const ButtonWrapper = styled(ButtonWrapperDefault)`
  margin-top: 64px;
`;

export const StickerRoot = styled(Sticker.Root)`
  margin-top: 30px;
`;

export const LoadingPane = styled(LoadingDs)`
  display: flex;
  margin: 10px auto;
`;

export const Loading = styled(LoadingDs)`
  display: flex;
  margin-top: 50px;
`;
